import { render, staticRenderFns } from "./TypographySidebar.vue?vue&type=template&id=0abe2998&scoped=true"
import script from "./TypographySidebar.vue?vue&type=script&lang=js"
export * from "./TypographySidebar.vue?vue&type=script&lang=js"
import style0 from "./TypographySidebar.vue?vue&type=style&index=0&id=0abe2998&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abe2998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abe2998')) {
      api.createRecord('0abe2998', component.options)
    } else {
      api.reload('0abe2998', component.options)
    }
    module.hot.accept("./TypographySidebar.vue?vue&type=template&id=0abe2998&scoped=true", function () {
      api.rerender('0abe2998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Settings/TypographySidebar.vue"
export default component.exports